import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  formTitle: {
    color: theme.palette.primary.main,
  },
  formTitleError: {
    color: theme.palette.error.main,
  },
  select: {
    "&:before": {
      borderColor: theme.palette.primary.main,
    },
    "&:after": {
      borderColor: theme.palette.primary.main,
    },
  },
  selectError: {
    "&:before": {
      borderColor: theme.palette.error.main,
    },
    "&:after": {
      borderColor: theme.palette.error.main,
    },
  },
}));

export default function DropdownComponent({
  currValue,
  items,
  handleChange,
  property,
  title,
  multi,
  error,
  itemIdSelector,
}) {
  const classes = useStyles();

  const changeValue = (event) => {
    handleChange(event.target.value);
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={error ? classes.formTitleError : classes.formTitle}>{title}</InputLabel>
      <Select
        value={currValue}
        onChange={changeValue}
        className={error ? classes.selectError : classes.select}
        multiple={multi === undefined ? false : multi}
      >
        {items.map((item, index) => {
          return (
            <MenuItem value={itemIdSelector ? itemIdSelector(item) : item} key={index}>
              {typeof item === "string" ? item : item[property]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
